import React, { useEffect, useRef } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { keyframes, css } from "@emotion/react";

let slideWidth = 476 + 20; // width + gap
if (window.innerWidth < 500) {
  slideWidth = 250 + 0; // width + gap
}
const InfiniteSlider = ({ slides, duration, ...rest }) => {
  const totalWidth = slideWidth * slides.length;
  const slideRef = useRef();

  const scrollAnimation = keyframes`
    0% { transform: translateX(0); }
    100% { transform: translateX(-${totalWidth}px); }
  `;

  useEffect(() => {
    const animation = slideRef.current.animate(
      { transform: [`translateX(0)`, `translateX(-${totalWidth}px)`] },
      {
        duration: slides.length * duration * 1000, // duration in milliseconds
        iterations: Infinity,
        easing: "linear",
      }
    );

    return () => animation.cancel();
  }, [totalWidth, duration, slides.length]);

  return (
    <Box
      overflow="hidden"
      width={`calc(${slideWidth * 3}px)`} // show 3 slides at a time
      mx="auto"
      position="relative"
      left="50%"
      transform="translate(-50%, 0px)"
      w="100vw"
      {...rest}
    >
      <Flex
        ref={slideRef}
        css={css`
          animation: ${scrollAnimation} ${slides.length * duration}s linear
            infinite;
          -webkit-animation: ${scrollAnimation} ${slides.length * duration}s
            linear infinite; /* Safari */
        `}
        width={`${totalWidth * 2}px`} // double the width for continuous effect
      >
        {slides.concat(slides).map((slide, i) => (
          <Box key={i} width="476px" boxSizing="border-box" mx="10px">
            {slide}
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default InfiniteSlider;
